/**
 * ENTRÉE DANS L'APPLICATION — LA RÈGLE, SANS LE DOM.
 *
 * Module PUR : il décide quelle séquence jouer et pendant combien de temps.
 * Il vit à part parce qu'une règle qui se teste sans navigateur se vérifie
 * vraiment — et parce que « quand ne PAS animer » compte autant que le reste.
 */

export type MotionLevel = 'full' | 'reduced' | 'minimal'
export type NavKind = 'navigate' | 'reload' | 'back_forward' | 'other'
export type EntryClass = 'lc-entering' | 'lc-entering-soft' | 'lc-booting'

export interface EntrySequence {
  classe: EntryClass | null
  duree: number
}

/**
 *   depuis /login   → séquence signature complète (inchangée)
 *   ouverture       → entrée application : la marque, le rail, le contenu
 *   rechargement    → version courte (§14) : F5 ne doit pas devenir pénible
 *   retour arrière  → rien (§50) : on ne rentre pas, on revient
 *   mouvement réduit→ version courte ; minimal → aucune animation
 *
 * Aucune branche ne dépend de la navigation INTERNE : le shell n'est monté
 * qu'une fois par document, donc un clic dans la barre latérale ne peut pas,
 * par construction, rejouer une entrée (§13).
 */
export function entrySequence(ctx: {
  fromLogin: string | null
  level: MotionLevel
  nav: NavKind
}): EntrySequence {
  if (ctx.level === 'minimal') return { classe: null, duree: 0 }
  if (ctx.fromLogin) {
    return ctx.fromLogin === 'full'
      ? { classe: 'lc-entering', duree: 950 }
      : { classe: 'lc-entering-soft', duree: 280 }
  }
  if (ctx.nav === 'back_forward') return { classe: null, duree: 0 }
  if (ctx.level !== 'full' || ctx.nav === 'reload') return { classe: 'lc-entering-soft', duree: 280 }
  return { classe: 'lc-booting', duree: 900 }
}
